export interface ResidentialIncentiveApiData {
    id: number;
    grantorName: string;
    grantorType: string;
    applicantType: string;
    incentiveName: string;
    description: string;
    type: string;
    supportFor: string;
    typicalAmount: string | null;
    limitations: string | null;
    detailsUrl: string;
    criteriaUrls: string[];
    maxAmount: number | null;
    applicableToNewVehicles: boolean;
    applicableToUsedVehicles: boolean;
    incomeDependent: boolean;
    applicableToFcevs: boolean;
    available: boolean;
    pointOfSale: boolean;
    mutuallyExclusivePrograms: string[];
    eligibleEquipment: string[];
}

export const emptyResidentialIncentiveData: ResidentialIncentiveApiData = {
    id: 0,
    grantorName: '',
    grantorType: '',
    applicantType: '',
    incentiveName: 'Invalid Incentive',
    description: '',
    type: '',
    supportFor: '',
    typicalAmount: null,
    limitations: null,
    detailsUrl: '',
    criteriaUrls: [],
    maxAmount: null,
    applicableToNewVehicles: false,
    applicableToUsedVehicles: false,
    incomeDependent: false,
    applicableToFcevs: false,
    available: false,
    pointOfSale: false,
    mutuallyExclusivePrograms: [],
    eligibleEquipment: [],
};

interface ResidentialIncentivesDataType {
    data: ResidentialIncentiveApiData[];
}

export default ResidentialIncentivesDataType;
